module.exports = __webpack_public_path__ + "static/media/41header.3143d181.jpg";